import React from 'react';
import { Target, Search, ShieldCheck, Eye, CheckSquare } from 'lucide-react';

const YuZuMethod = () => {
  const methodSteps = [
    {
      icon: <Target className="h-6 w-6" />,
      title: "Role Risk Clarification",
      description: "We define operational pressure points and expectations before sourcing begins. No generic job descriptions."
    },
    {
      icon: <Search className="h-6 w-6" />,
      title: "Behavioural & Reliability Screening",
      description: "We assess accountability, pressure handling, consistency, and team impact, not only technical skills."
    },
    {
      icon: <ShieldCheck className="h-6 w-6" />,
      title: "Reference & Integrity Verification",
      description: "Structured validation processes, not informal checks. Every claim is verified."
    },
    {
      icon: <Eye className="h-6 w-6" />,
      title: "Two-Stage Founder Evaluation",
      description: "Every candidate is screened by Marché for behaviour and reliability, then interviewed by Ciara for operational capability. No candidate is presented without passing both."
    },
    {
      icon: <CheckSquare className="h-6 w-6" />,
      title: "Controlled Shortlist Delivery",
      description: "Only aligned candidates are presented. No volume CV flooding. Quality over quantity."
    }
  ];

  return (
    <section id="method" className="py-20 bg-[#21242C] border-t border-gray-700">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-normal text-white mb-6" style={{ fontFamily: "'DM Serif Display', serif", textShadow: 'none', WebkitFontSmoothing: 'antialiased' }}>
            The YuZu Method
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto" style={{ fontFamily: "'DM Serif Display', serif" }}>
            Structured risk reduction through founder-led oversight and behavioural screening.
          </p>
        </div>

        <div className="space-y-12">
          {methodSteps.map((step, index) => (
            <div 
              key={index}
              className="bg-[#2a2e38] border border-gray-700 rounded-lg p-8 hover:border-[#FFD000] transition-all duration-300 group"
            >
              <div className="flex items-start space-x-5">
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 bg-[#FFD000]/10 rounded-lg flex items-center justify-center text-[#FFD000] group-hover:bg-[#FFD000] group-hover:text-black transition-all duration-300">
                    {step.icon}
                  </div>
                </div>
                <div className="flex-1">
                  <div className="flex items-center mb-2">
                    <span className="text-xl font-bold text-[#FFD000] mr-3">
                      {String(index + 1).padStart(2, '0')}
                    </span>
                    <h3 className="text-lg font-normal text-white">
                      {step.title}
                    </h3>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-base text-white font-semibold">
            We assess. We filter. We validate. We present.
          </p>
          <p className="text-gray-400 mt-2 text-sm">Never: "We try." "We aim." "We hope."</p>
        </div>
      </div>
    </section>
  );
};

export default YuZuMethod;
